import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
  // Скролл вверх при загрузке страницы
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-lunar-gradient py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-lunar-800/50 backdrop-blur-sm rounded-2xl p-8 border border-[var(--primary-color-800-30)]">
          <div className="space-y-8 text-lunar-300">
            <div>
              <h1 className="text-3xl font-bold text-white mb-4">
                Политика конфиденциальности
              </h1>
              <p className="text-sm text-lunar-400">
                Последнее обновление: 13 октября 2025 г. в 12:43
              </p>
            </div>
            
            <div>
              <h3 className="font-semibold text-white mb-2">
                Официальное предложение администратора
              </h3>
              <p className="mb-4">
                Настоящая Политика конфиденциальности является официальным предложением администратора интернет-сайта {process.env.REACT_APP_SITE_URL || 'gekata.net'}
              </p>
              <p className="mb-3">
                <strong>{process.env.REACT_APP_COMPANY_NAME || 'ИП Бобров Илья Николаевич'}</strong>, ИНН: {process.env.REACT_APP_COMPANY_INN || '000000000000'}, ОГРН: {process.env.REACT_APP_COMPANY_OGRN || '000000000000000'}, далее именуемого "Администратор", заключить настоящее Соглашение в форме публичной оферты на нижеизложенных условиях и адресовано: любому физическому лицу, достигшему 18 лет и являющемуся полностью дееспособным, далее именуемому "Пользователь", совместно именуемые "Стороны", а каждый в отдельности "Сторона".
              </p>
              <p className="mb-3">
                В случае, если вам не подходит данная Политика, пожалуйста, не используйте наши услуги. Мы обязуемся соблюдать конфиденциальность ваших данных и защищать их от несанкционированного доступа в соответствии с действующим законодательством.
              </p>
              <p className="mb-4">
                Мы собираем только те персональные данные, которые необходимы для предоставления наших услуг. Примеры таких данных включают, но не ограничиваются, следующие: имя, адрес электронной почты, и другая информация, предоставляемая вами при регистрации или взаимодействии с сервисами.
              </p>
            </div>
          {/* 1. Общие положения */}
          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">
              1. Общие положения
            </h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold text-white mb-3">
                  1.1. Область действия
                </h3>
                <p className="text-lunar-300">
                  Настоящая Политика, размещенная в сети Интернет по адресу: {process.env.REACT_APP_SITE_URL || 'gekata.net'}/privacy-policy и регулирует порядок сбора, использования, обработки и защиты информации о Пользователях Платформы.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  1.2. Законодательное регулирование
                </h3>
                <p className="text-lunar-300">
                  Отношения, связанные со сбором, хранением, распространением и защитой информации о Пользователях Платформы, регулируются настоящей Политикой и действующим законодательством Российской Федерации.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  1.3. Изменения в Политике
                </h3>
                <p className="text-lunar-300">
                  Действующая редакция Политики, являющейся публичным документом, доступна любому пользователю сети Интернет при переходе по ссылке: {process.env.REACT_APP_SITE_URL || 'gekata.net'}/privacy-policy. Администрация Платформы вправе вносить изменения в настоящую Политику. В целях ознакомления с актуальной редакцией Политики Пользователям рекомендуется регулярно производить ознакомление с текстом настоящей Политики. Продолжение использования Платформы Пользователем после внесения изменений и/или дополнений в настоящую Политику означает принятие и согласие Пользователя с такими изменениями и/или дополнениями.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  1.4. Связь с Пользовательским соглашением
                </h3>
                <p className="text-lunar-300">
                  Настоящая Политика разработана и используется в соответствии с Пользовательском соглашением платформы {process.env.REACT_APP_SITE_NAME || 'Gekata'}, доступном по адресу: {process.env.REACT_APP_SITE_URL || 'gekata.net'}/terms-of-service
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  1.5. Согласие пользователя
                </h3>
                <p className="text-lunar-300">
                  Регистрируясь и используя Платформе, Пользователь выражает свое согласие с условиями настоящей Политики.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  1.6. Сбор персональных данных
                </h3>
                <p className="text-lunar-300">
                  Сбор персональных данных, а также иной информации, которая не относится к персональным данным, осуществляется на Платформе при регистрации и/или авторизации путем заполнения Пользователем регистрационной формы а, а также в дальнейшем при редактировании Пользователем ранее предоставленной информации либо при дополнении по своей инициативе персональных данных (если применимо) с помощью функционала Платформы.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  1.7. Несогласие с условиями
                </h3>
                <p className="text-lunar-300">
                  В случае несогласия Пользователя с условиями настоящей Политики использование Платформы должно быть немедленно прекращено.
                </p>
              </div>
            </div>
          </section>

          {/* 2. Цели обработки информации */}
          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">
              2. Цели обработки информации
            </h2>
            <div>
              <h3 className="font-semibold text-white mb-3">
                2.1. Основные цели обработки
              </h3>
              <p className="text-lunar-300">
                Администрация Платформы осуществляет обработку информации о Пользователях, в том числе персональные данные, в целях выполнения обязательств Администрации Платформы перед Пользователями в отношении использования функционала Платформы.
              </p>
            </div>
          </section>

          {/* 3. Состав информации о Пользователях */}
          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">
              3. Состав информации о Пользователях
            </h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold text-white mb-3">
                  3.1. Категории данных
                </h3>
                <p className="text-lunar-300">
                  Ниже указаны категории данных, которые Администрация Платформы собирает и обрабатывает, когда Пользователь получает доступ к Платформе и использует её.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  3.2. Персональные данные для регистрации
                </h3>
                <p className="text-lunar-300 mb-3">
                  <strong>Данные:</strong> адрес электронной почты
                </p>
                <p className="text-lunar-300 mb-3">
                  <strong>Цель обработки:</strong> Эта информация является минимально необходимой для регистрации Пользователя на Платформе. Администрация Платформы использует эту информацию для управления Платформой, включая предоставление Пользователю доступа к Платформе. Администрация Платформы использует эти данные, чтобы выполнить свои обязательства перед Пользователем как часть функциональности Платформы (например, в тех случаях, когда Пользователь запрашивает восстановление доступа к профилю на Платформе).
                </p>
                <p className="text-lunar-300">
                  <strong>Юридические основания:</strong> Исполнение договора между Администрацией Платформы и Пользователем
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  3.3. Дополнительные данные
                </h3>
                <p className="text-lunar-300 mb-3">
                  <strong>Данные:</strong> которые Пользователь предоставляет при редактировании и/или дополнении своей анкеты на Платформе
                </p>
                <p className="text-lunar-300 mb-3">
                  <strong>Цель обработки:</strong> Администрация Платформы использует эту информацию для управления Платформой, включая предоставление Пользователю доступа к Платформе и предоставление Пользователю услуг Платформы.
                </p>
                <p className="text-lunar-300">
                  <strong>Юридические основания:</strong> Исполнение договора между Администрацией Платформы и Пользователем
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  3.4. Информация запросов
                </h3>
                <p className="text-lunar-300 mb-3">
                  <strong>Данные:</strong> Информация, указанная Пользователем при направлении запросов к Администрации Платформы.
                </p>
                <p className="text-lunar-300 mb-3">
                  <strong>Цель обработки:</strong> Администрация Платформы использует эту информацию, чтобы верифицировать Пользователя и исполнить его запрос.
                </p>
                <p className="text-lunar-300">
                  <strong>Юридические основания:</strong> Законные интересы. Исполнение договора между Администрацией Платформы и Пользователем
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  3.5. Исполнение договора
                </h3>
                <p className="text-lunar-300">
                  Администрация Платформы осуществляет обработку персональных данных Пользователя в целях исполнения договора между Администрацией Платформы и Пользователем на предоставление Администрацией Платформы Пользователю доступа к использованию Платформы и его функционала (п. 2.1 Пользовательского соглашения платформы {process.env.REACT_APP_SITE_NAME || 'Gekata'} {process.env.REACT_APP_SITE_URL || 'gekata.net'}/terms)
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  3.6. Хранение данных
                </h3>
                <p className="text-lunar-300">
                  Персональные данные пользователей хранятся исключительно на электронных носителях и обрабатываются с использованием автоматизированных систем, за исключением случаев, когда неавтоматизированная обработка персональных данных необходима в связи с исполнением требований законодательства.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  3.7. Уничтожение данных
                </h3>
                <p className="text-lunar-300">
                  Персональные данные Пользователя уничтожаются при: при самостоятельном удалении Пользователем своей учетной записи на Платформе; удалении Администрацией Платформы профиля в случае получения от Пользователя письменного отказа от обработки персональных данных.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  3.8. Сроки хранения после удаления
                </h3>
                <p className="text-lunar-300">
                  В случае удаления профиля Администрация Платформы хранит на своих электронных носителях персональные и иные необходимые данные Пользователя в течение необходимого и установленного действующим законодательством Российской Федерации срока.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  3.9. Доступность данных другим пользователям
                </h3>
                <p className="text-lunar-300">
                  Размещая свои персональные данные в учетной записи, Пользователь осознает и соглашается с тем, что указанная информация может быть доступна другим Пользователям Платформы с учетом особенностей архитектуры и функционала Платформы.
                </p>
              </div>
            </div>
          </section>

          {/* 4. Меры по защите информации */}
          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">
              4. Меры по защите информации о Пользователях
            </h2>
            
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-white mb-3">
                  4.1. Технические и организационно-правовые меры
                </h3>
                <p className="text-lunar-300">
                  Администрация Платформы принимает технические и организационно-правовые меры в целях обеспечения защиты персональных данных Пользователя от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  4.2. Принципы обработки персональных данных:
                </h3>
                <ul className="text-lunar-300 space-y-2">
                  <li><strong>4.2.1.</strong> законности целей и способов обработки персональных данных;</li>
                  <li><strong>4.2.2.</strong> добросовестности;</li>
                  <li><strong>4.2.3.</strong> соответствия целей обработки персональных данных целям, заранее определенным и заявленным при сборе персональных данных;</li>
                  <li><strong>4.2.4.</strong> соответствия объема и характера обрабатываемых персональных данных, способов обработки персональных данных целям обработки персональных данных;</li>
                  <li><strong>4.2.5.</strong> недопустимости объединения созданных для несовместимых между собой целей баз данных, содержащих персональные данные.</li>
                </ul>
              </div>
            </div>
          </section>

          {/* 5. Передача персональных данных */}
          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">
              5. Передача персональных данных
            </h2>
            <div>
              <h3 className="font-semibold text-white mb-3">
                5.1. Ограничения передачи
              </h3>
              <p className="text-lunar-300">
                Персональные данные Пользователей не передаются каким-либо третьим лицам, за исключением случаев, прямо предусмотренных настоящей Политикой, Пользовательским соглашением платформы {process.env.REACT_APP_SITE_NAME || 'Gekata'}.
              </p>
            </div>
          </section>

          {/* 6. Ограничение действия Политики */}
          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">
              6. Ограничение действия Политики
            </h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-white mb-3">
                  6.1. Третьи лица
                </h3>
                <p className="text-lunar-300">
                  Действие настоящей Политики не распространяется на действия и интернет-ресурсы третьих лиц.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  6.2. Ответственность
                </h3>
                <p className="text-lunar-300">
                  Администрация Платформы не несет ответственности за действия третьих лиц, получивших в результате использования Платформы доступ к информации о Пользователе, за последствия использования информации, которая, в силу природы Платформы, доступна любому Пользователю Платформы. Администрация Платформы рекомендует Пользователям ответственно подходить к решению вопроса об объеме информации о себе, размещаемой на Платформе.
                </p>
              </div>
            </div>
          </section>

          {/* 7. Обращения пользователей */}
          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">
              7. Обращения пользователей
            </h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-white mb-3">
                  7.1. Право направлять запросы
                </h3>
                <p className="text-lunar-300">
                  Пользователи вправе направлять Администрации Платформы свои запросы, в том числе запросы относительно использования их персональных данных, в электронной форме по электронной почте: {process.env.REACT_APP_SUPPORT_EMAIL || 'help@gekata.net'}
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  7.2. Сроки рассмотрения
                </h3>
                <p className="text-lunar-300">
                  Администрация Платформы обязуется рассмотреть и направить ответ на поступивший запрос Пользователя в течение 30 дней с момента поступления обращения.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  7.3. Конфиденциальность корреспонденции
                </h3>
                <p className="text-lunar-300">
                  Вся корреспонденция, полученная Администрацией Платформы от Пользователей (обращения в письменной или электронной форме), относится к информации ограниченного доступа и не разглашается без письменного согласия Пользователя. Персональные данные и иная информация о Пользователе, направившем запрос, не могут быть без специального согласия Пользователя использованы иначе, как для ответа по теме полученного запроса или в случаях, прямо предусмотренных законодательством.
                </p>
              </div>
            </div>
          </section>


          <div className="mt-12 pt-8 border-t border-[var(--primary-color-800-30)]">
            <div className="text-left">
              <h3 className="text-lg font-semibold text-white mb-4">Контакты для связи</h3>
              <div className="text-lunar-300">
                <p>Email: {process.env.REACT_APP_SUPPORT_EMAIL || 'support@example.com'}</p>
                <p>Телефон: {process.env.REACT_APP_SUPPORT_PHONE || '+7 (000) 000-00-00'}</p>
              </div>
              
              <div className="mt-6 text-sm text-lunar-400">
                <p>{process.env.REACT_APP_COMPANY_NAME || 'Gekata'}</p>
                <p>ИНН: {process.env.REACT_APP_COMPANY_INN || '000000000000'}</p>
                <p>ОГРН: {process.env.REACT_APP_COMPANY_OGRN || '000000000000000'}</p>
                <p>{process.env.REACT_APP_COMPANY_ADDRESS || 'Адрес компании'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default PrivacyPolicy;
